import { render, staticRenderFns } from "./FreeUpdate.vue?vue&type=template&id=7ff0994a&scoped=true"
import script from "./FreeUpdate.vue?vue&type=script&lang=js"
export * from "./FreeUpdate.vue?vue&type=script&lang=js"
import style0 from "./FreeUpdate.vue?vue&type=style&index=0&id=7ff0994a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff0994a",
  null
  
)

export default component.exports